import { ProcessingStatus } from "@/hooks/useKeyValOperations"
import { sortByCreatedAtDesc } from "@/utils/agent"

export interface BaseRow {
  created_at?: string;
  updated_at?: string;
}

export type RowWithStatus<T extends BaseRow> = T & {
  _status: ProcessingStatus;
  _id: string;
}

export function processBucketRows<T extends BaseRow>(
  rows: T[],
  status: ProcessingStatus,
  rowIdRef: { current: number }
): RowWithStatus<T>[] {
  if (rows.length === 0) {
    return [];
  }

  const rowsWithStatus = sortByCreatedAtDesc(
    rows.map((row: T) => ({
      ...row,
      _status: status,
      _id: `row_${rowIdRef.current++}`,
    }))
  );

  return rowsWithStatus;
}
